import { CarouselGalleryUI } from "./CarouselGalleryUI";
import { StandardProps } from "../../componentMap";
import { useVariant } from "../../../hooks/useVariant/useVariant";
import { isAvailableToOrder } from "../../../utils/product/isAvailableToOrder";

export function CarouselGallery({
  product,
  sizes,
  configProps,
  experiences,
}: Pick<StandardProps, "product" | "experiences"> & {
  sizes: string;
  configProps?: {
    SocialProofMessages?: {
      appId: string;
      withClose?: boolean;
    };
    hasTransparentThumbnails?: boolean;
  };
}) {
  const { variant } = useVariant(product);
  const media = "media" in product ? product.media : null;
  const videos = media?.videos || [];
  const socialProofMessagesProperties =
    product.__typename === "SimpleProduct" && configProps?.SocialProofMessages
      ? {
          ...configProps.SocialProofMessages,
          productId: product.aliases.pimProductId,
          brand: product.brand.name,
          availableToOrder: isAvailableToOrder(product),
        }
      : undefined;

  if (!variant) return null;

  return (
    <CarouselGalleryUI
      title={variant.title}
      images={variant.images}
      videos={videos}
      sizes={sizes}
      hasSocialProofMessagesExperience={true}
      hasImmediateStateUpdates={experiences.hasImmediateStateUpdates === "true"}
      socialProofMessagesProperties={socialProofMessagesProperties}
      hasTransparentThumbnails={configProps?.hasTransparentThumbnails}
      hasDeferredMonetateQEvents={
        experiences.hasDeferredMonetateQEvents === "true"
      }
      hasDeferredIntersectionObserverCallback={
        experiences.hasDeferredIntersectionObserverCallback === "true"
      }
      hasSuperZoom={experiences.isSuperZoomDisabled !== "true"}
    />
  );
}
